import React from 'react';

interface LocationIconProps {
  color: string;
}

const LocationIcon: React.FC<LocationIconProps> = () => (
  <svg width="24" height="24" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0625 10.0626C11.5122 10.0626 12.6875 8.88737 12.6875 7.43762C12.6875 5.98787 11.5122 4.81262 10.0625 4.81262C8.61275 4.81262 7.4375 5.98787 7.4375 7.43762C7.4375 8.88737 8.61275 10.0626 10.0625 10.0626Z"
      stroke="black"
      strokeWidth="0.72489"
      strokeMiterlimit="10"
    />
    <path
      d="M16.1875 7.4375C16.1875 5.81305 15.5422 4.25513 14.3935 3.10647C13.2449 1.95781 11.687 1.3125 10.0625 1.3125C8.43805 1.3125 6.88013 1.95781 5.73147 3.10647C4.58281 4.25513 3.9375 5.81305 3.9375 7.4375C3.9375 10.8202 10.0625 19.6875 10.0625 19.6875C10.0625 19.6875 16.1875 10.8202 16.1875 7.4375Z"
      stroke="black"
      strokeWidth="0.72489"
      strokeMiterlimit="10"
    />
  </svg>
);

export default LocationIcon;
